<a
  mat-list-item
  class="!px-3.5 mb-3 hover:!rounded-3xl"
  [routerLink]="navigationItem.route"
  routerLinkActive="selected-menu-item !rounded-3xl"
  i18n-aria-label
  aria-label="Navigation links"
>
  <div mat-list-item class="flex flex-row items-center">
    <lib-app-icon [icon]="navigationItem.icon" [size]="'16x20'" />
    @defer{
      @if(!collapsed) {
        <span class="flex justify-center pl-2">
          {{ navigationItem.label }}
        </span>
      }
    }
  </div>
</a>